import $ from 'jquery';
import _ from 'underscore';
import { inlineDownloadWithoutFilterstateAndSegmentPlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { treePlugin } from '@bingads-webui/projection-grid-tree';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { performanceLogPlugin, perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { clientSideSortPlugin } from '@bingads-webui/projection-grid-client-sort';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { jsdataRawDataPlugin } from '@bingads-webui-campaign/projection-grid-js-data-raw-data';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
// import { crossPageSelectAllPlugin } from '@bingads-webui/projection-grid-cross-page-select-all';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
// import { aggregatedRowsPlugin } from '@bingads-webui/projection-grid-aggregated-rows';
import { aggregatedRowsPluginBuilder } from '@bingads-webui-campaign/pgrid-aggregated-rows';
import { getColumnChooserPluginConfig, isEveryThingElseRow, getSortReturn } from './common/view/product-groups-columns';

const appConfig = globalContext.require('component/config/index');
const permissions = appConfig.get('Permissions');

export function getPlugins({
  view,
  filterService,
  deps,
  isTreeView,
  p$daterange,
  perfMarker,
}) {
  // view = view;
  // deps = deps;
  // isTreeView = isTreeView;
  const ReportEmailRule = deps.state.get('$ReportEmailRule');
  deps.state.unset('$ReportEmailRule');

  const processReportRule = (ReportRule) => {
    // Remove Warnings column in Headers
    // Warnings column will always be the third element in the Array
    const warningColumnHeaderIdx = ReportRule.Headers.indexOf(deps.i18n.getString('ProductGroupsGrid_ColumnName_Warnings'));
    if (warningColumnHeaderIdx > 0) {
      ReportRule.Headers.splice(warningColumnHeaderIdx, 1);
    }
    return _.defaults({
      Selection: _.defaults({
        IsAdGroupTreeView: isTreeView,
        QueryString: ReportRule.Selection.QueryString.replace(',Warnings', ''),
      }, ReportRule.Selection),
    }, ReportRule);
  };

  const columnChooserConfig = getColumnChooserPluginConfig(deps, view, isTreeView);
  columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';

  const aggregatedRowsPlugin = aggregatedRowsPluginBuilder({
    i18n: deps.i18n,
    keys: {
      overallI18nKey: 'ProductGroupGrid_Total',
      filteredI18nKey: 'ProductGroupGrid_Filtered_Total',
    },
    permissions,
    filterService,
    customConfig: {
      showSearchRow: false,
      showAudienceRow: false,
      showNativeRow: false,
      showDeletedRow: false,
    },
  });

  if (isTreeView) {
    return [{
      plugin: perfMarkerPlugin,
      config: { appConfig: deps.config, marker: perfMarker },
    }, {
      plugin: inlineDownloadWithoutFilterstateAndSegmentPlugin,
      config: {
        DownloadView: deps.DownloadView,
        isAvailable: true,
        i18n: deps.i18n,
        s$i18n: deps.s$i18n,
        schema: deps.s$ProductGroup,
        gridId: 'newProductGroupsGrid',
        ReportEmailRule,
        processReportRule,
        p$daterange,
      },
    }, {
      plugin: uiBlockerPlugin,
      config: {
        el: $('.product-groups-page-hierarchy'),
      },
    }, {
      plugin: treePlugin,
      config: {
        toggleColumnName: 'ProductGroup',
        templateDecorator: celTemplate => ({ value }) => {
          if (!_.isEmpty(value.total)) {
            return celTemplate({
              total: value.total,
            });
          }
          // hack to get parent item
          const parentItem = view.grid.gridView.itemWithKey(value.ParentId);
          let attributeText = value.Condition.value.Attribute;
          const isRoot = _.isEmpty(value.Condition.value.Operand);

          if (isRoot) {
            // Root node
            attributeText = deps.i18n.getString('ShoppingCampaign_AllProducts');
          } else if (_.isEmpty(value.Condition.value.Attribute)) {
            if (!parentItem.Condition.Attribute && parentItem.Condition.Operand) {
              // Parent node is everything else
              attributeText = deps.i18n.getString('ProductGroupsGrid_EverythingElse');
            } else {
              // Everything else in `parent's attribute`
              const parentAttribute = parentItem.Condition.Attribute || deps.i18n.getString('ShoppingCampaign_AllProducts');

              attributeText = deps.i18n.getString('ProductGroupsGrid_EverythingElseIn').replace('{0}', parentAttribute);
            }
          }

          return celTemplate(_.defaults({ i18n: deps.i18n }, value.Condition, {
            attributeText,
            isRoot,
          }));
        },
      },
    }, {
      plugin: performanceLogPlugin,
      config: {
        appConfig: deps.config,
        logger: deps.logger,
      },
    }, {
      plugin: columnChooserPlugin,
      config: columnChooserConfig,
    }, {
      plugin: clientSideSortPlugin,
      config: {
        compareMaker: (sortIteratee, direction, columnKey) => (item1, item2) => {
          // if current sorting column is product group name
          if (columnKey === 'Condition/Attribute') {
            // direction: -1 for desc, 1 for asc
            if (isEveryThingElseRow(item1)) {
              return 1;
            }

            if (isEveryThingElseRow(item2)) {
              return -1;
            }
          }

          const sortReturn =
            getSortReturn(
              sortIteratee(item1, direction),
              sortIteratee(item2, direction), columnKey
            );
          return sortReturn;
        },
        setTopToMax: true,
      },
    }, {
      plugin: dateFilterPlugin,
      config: {
        state: deps.state,
        addDateChangeListener: _.noop,
        edm: deps.edmCampaign,
        isOdataActionSource: true,
        comparisonColumns: [],
        p$daterange,
      },
    }, {
      plugin: jsdataRawDataPlugin,
    }, {
      plugin: assistedSelectionPlugin,
    }, {
      plugin: editablePlugin,
      config: { i18n: deps.i18n },
    }, {
      plugin: inlineErrorPlugin,
    }, {
      plugin: a11yPlugin,
      config: { i18n: deps.i18n },
    }];
  }
  return [{
    plugin: perfMarkerPlugin,
    config: { appConfig: deps.config, marker: perfMarker },
  }, {
    plugin: jsdataRawDataPlugin,
  }, {
    plugin: paginationPlugin,
    config: {
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      preferenceService: deps.preferenceService,
      pageSizeText: deps.i18n.getString('Grid_ShowRows'),
      totalPageCountText: deps.i18n.getString('Grid_PageOf'),
    },
  }, {
    plugin: dateFilterPlugin,
    config: {
      state: deps.state,
      addDateChangeListener: _.noop,
      edm: deps.edmCampaign,
      isOdataActionSource: true,
      comparisonColumns: [],
      p$daterange,
    },
  }, {
  //   plugin: crossPageSelectAllPlugin,
  // }, {
    plugin: performanceLogPlugin,
    config: {
      appConfig: deps.config,
      logger: deps.logger,
    },
  }, {
    plugin: columnChooserPlugin,
    config: columnChooserConfig,
  }, {
    plugin: editablePlugin,
    config: { i18n: deps.i18n },
  }, {
    plugin: assistedSelectionPlugin,
  }, {
    plugin: uiBlockerPlugin,
    config: {
      el: $('.product-groups-page-list'),
    },
  }, {
    plugin: inlineDownloadWithoutFilterstateAndSegmentPlugin,
    config: {
      DownloadView: deps.DownloadView,
      isAvailable: true,
      i18n: deps.i18n,
      s$i18n: deps.s$i18n,
      schema: deps.s$ProductGroup,
      gridId: 'newProductGroupsGrid',
      ReportEmailRule,
      processReportRule,
      p$daterange,
    },
  }, {
    plugin: aggregatedRowsPlugin,
  }, {
    plugin: a11yPlugin,
    config: { i18n: deps.i18n },
  }];
}
